import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { HttpService } from '../../services/http.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-symptom-details',
  standalone: true,
  imports: [CommonModule, NzDividerModule, TranslateModule, NzIconModule],
  templateUrl: './symptom-details.component.html',
  styleUrls: ['./symptom-details.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SymptomDetailsComponent implements OnInit {
  reportDetails: any;
  symptomData: any = {
    reference: {
      date: '',
      hours: '',
    },
  };
  onMobile: boolean = false;

  constructor(
    private router: Router,
    private http: HttpService,
    private route: ActivatedRoute,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.onMobile = window.innerWidth <= 768;
    const consultDate = this.route.snapshot.paramMap.get('consultDate');

    if (consultDate) {
      const [date, time] = consultDate.split(' ');
      this.symptomData.reference.date = date;
      this.symptomData.reference.hours = time;
    }

    this.dataService.getSessionId().subscribe(sessionId => {
      if(sessionId){
        this.http.getReportDetails(sessionId).subscribe((details) => {
        this.reportDetails = details;
        })
      } else {
        console.warn('Session ID non trovato')
      }
    })
    
  }

  protected back(): void {
    this.router.navigate(['/symptom-assessment']);
  }

  printSection(): void {
    const printContent = document.getElementById('print-section');
    const WindowPrt = window.open('', '', 'width=800,height=600');
  
    if (WindowPrt && printContent) {
      WindowPrt.document.write(`
        <html>
          <head>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);
      WindowPrt.document.close();
      WindowPrt.focus();
      WindowPrt.print();
      WindowPrt.close();
    }
  }


}

